module.exports = __webpack_public_path__ + "img/medium.fd0ff251.svg";